import { Color } from './color.model';
import { BehaviorSubject } from 'rxjs';
export interface AnswerConfirmation {
  Title: string;
  Description: string;
  CtaText: string;
  CtaLink: string;
  CtaDataT: string;
  CtaDataD1: string;
  NodeId: number;
  ModalIds: number[];
  NextActionClassName: string;
  LinkedActionNodeId: number;
  ProductNodeAlias: string;
}

export class Modal {
  private messageSource = new BehaviorSubject<boolean>(true);

  public Text: string;
  public Image: string;
  public Title: string;
  public ButtonText: string;
  public Button2Text: string;
  public PopupFilter: string;
  public NodeId: string;
  public HideModal: boolean = true;
  public currentMessage = this.messageSource.asObservable();

  constructor(
    init?: Partial<Modal>
  ) {
    Object.assign(this, init);
  }

  private defaultAction() {
    this.HideModal = true;
    this.modalStatus(true);
  }

  clickOutsideModal() {
    this.defaultAction();
  }
  modalStatus(hideModal: boolean) {
    this.messageSource.next(hideModal);
  }
  ButtonClickFunction() {
    this.defaultAction();
  }
  Button2ClickFunction() {
    this.defaultAction();
  }
}

export class Answer {
  NextActionClassName: string;
  NodeId: number;
  DocumentGUID: string;
  NodeParentId: number;
  QuestionType: string;
  Title: string;
  Subtitle: string;
  Image: string;
  OverrideImage: boolean;
  ImageAlt: string;
  LinkedActionNodeId: number;
  AnswerConfirmationNodeId: number;
  ProductNodeAlias: string;
  DocumentPageTitle: string;
  DocumentPageDescription: string;
  DocumentPageKeyWords: string;
  ProjectTypeFilter: string;
  WoodGrainFilter: string;
  OpacityFilter: string;
  WoodTypeFilter: string;
  WoodConditionFilter: string;
  WoodLookFilter: string;
  EliteFilter: string;
  ProductQualityFilter: string;
  WoodDamageFilter: string;
}

export interface Question {
  Progress: string;
  Description: string;
  NodeId: number;
  Text: string;
  DocumentPageTitle: string;
  DocumentPageDescription: string;
  DocumentPageKeyWords: string;
  AnswerIds: number[];
}

export interface Step {
  Answers: Answer[];
  Question: Question;
}






// WEBPACK FOOTER //
// ./src/app/models/qa.model.ts